import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { ButtonModule } from 'primeng/button';
import { TranslateDirective } from '@ngx-translate/core';
import { CommentAuthorComponent } from '@app/shared/components/comment/comment-author/comment-author.component';
import { TruncationDetectorDirective } from '@app/shared/directives/truncation-detector.directive';
import { NgClass } from '@angular/common';

@Component({
  selector: 'gc-comment-card',
  templateUrl: './comment-card.component.html',
  styleUrl: './comment-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommentAuthorComponent,
    ButtonModule,
    SvgIconComponent,
    TranslateDirective,
    TruncationDetectorDirective,
    NgClass,
  ],
})
export class CommentCardComponent {
  public authorName = input.required<string>();
  public authorDate = input.required<string>();
  public message = input.required<string>();
  public showBorder = input<boolean>(false);
  public showReadMoreButton = input<boolean>(false);
  public showCommentLabel = input<boolean>(false);
  public truncateMessage = input<boolean>(false);

  public readMore = output<void>();
}
